export const BPC_NEW_PORTAL_LINK = 'https://portal.bancontactpro.com/';

export const BUCKAROO_PORTAL_LINK = 'https://my.buckaroo.io/';

export const BEL_SUPPORT_EMAIL = 'info@bancontact.com';

export const LUX_SUPPORT_EMAIL = 'wecare@buckaroo.eu';
